import {
  UPDATE_USER,
  UPDATE_GLOBAL_DATA
} from './mutation-types'

export default {
  [UPDATE_USER] (state, payload) {
    state.user = Object.assign({}, state.user, payload)
  },
  [UPDATE_GLOBAL_DATA] (state, payload) {
    state.globalData = Object.assign({}, state.globalData, payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js